/**
 * DevExtreme (esm/__internal/ui/tab_panel/item.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { noop } from "../../../core/utils/common";
import CollectionWidgetItem from "../../ui/collection/item";
class TabPanelItem extends CollectionWidgetItem {
  _renderWatchers() {
    this._startWatcher("badge", noop);
    super._renderWatchers();
  }
}
export { TabPanelItem as default };